import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";
import SwapHorizIcon from "@mui/icons-material/SwapHorizOutlined";

export const DragDividersHint: FC = () => {
  const { t } = useTranslation();

  return (
    <Typography
      variant="body2"
      color="text.secondary"
      className="flex items-center gap-1.5"
    >
      <SwapHorizIcon fontSize="small" aria-hidden />
      {t("views.categoryTemplates.shootTime.dragDividersHint")}
    </Typography>
  );
};
